import { TrlManageOrderButton } from './TrlManageOrderButton';

export { TrlManageOrderButton } from './TrlManageOrderButton';
export default TrlManageOrderButton;
